import type { FaireBrandEntity } from "../../entity_types/brand";

export const caden_lane: FaireBrandEntity = {
  token: "caden-lane",
  type: "brand",
  name: "Caden Lane",
  location: "Boerne, TX",
  minimumOrderDollars: 150,
  rating: 4.9,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
